import { List } from '../List'
import { Bibliography } from './Bibliography'

export class MagazineParent extends List {
  constructor(obj) {
    super(Magazine, obj)
  }
}

export class Magazine {
  constructor(obj) {
    this.id = obj?.id || null
    this.bibliography = (obj?.bibliography && new Bibliography(obj?.bibliography)) || null
    this.eissn = obj?.eissn || null
    this.impactFactor = obj?.impactFactor || null
    this.name = obj?.name || null
    this.publisher = obj?.publisher || null
    this.issn = obj?.issn || null
    this.isActual = obj?.id ? obj?.isActual : true
  }

  getForAPI() {
    return {
      id: this.id,
      bibliography: this.bibliography.getForAPI(),
      eissn: this.eissn,
      impactFactor: this.impactFactor,
      name: this.name,
      publisher: this.publisher,
      issn: this.issn,
      isActual: this.isActual
    }
  }
}
